module.exports = __webpack_public_path__ + "static/media/gestor_devices.3903db1c.png";